<template lang="pug">
  resp-img.blend-multiply(:bg="true", :useHeight="true", :src="image.src", :alt="image.alt", :bgClass="bgClass")
</template>

<script>
import { getFilename } from '@/utils'
import RespImg from '@/components/RespImg'
export default {
  name: 'Product__Image',
  props: ['image'],
  computed: {
    filename () {
      return this.image && getFilename(this.image.src)
    },
    bgClass () {
      // custom setting in filename "bg-..."
      const code = this.filename.match(/bg((_|-)[a-z]+)+/g) || []
      if (code[0]) return code[0].split('_').slice(1).reduce((acc, curr) => { acc += `bg-${curr} ` }, '')
      // default
      return 'bg-center bg-cover lg-bg-contain lg-bg-bottom'
    }
  },
  components: { RespImg }
}
</script>

<style>
</style>
